module.exports = __webpack_public_path__ + "static/2-524713e411db9ef427ea2a047bc09dba.jpg";